module.exports = __webpack_public_path__ + "static/media/pakiet_1200X900_03zakladka.86cea104.jpg";